/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import {graphql, useStaticQuery} from "gatsby"
import {Helmet} from "react-helmet"
import PropTypes from "prop-types"


function Seo({ description, lang, meta, article, title, image, url, topics, authors }) {
    const { site } = useStaticQuery(
        graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
    )

    const metaDescription = description || site.siteMetadata.description
    const defaultTitle = site.siteMetadata?.title
    let topicList = []

    if (topics) {
        topics.nodes.forEach(function (node, index) {
            topicList.push(`'topic${index}': '${node.name}'`)
        })
    }

    if (authors) {
        authors.forEach(function (node, index) {
            topicList.push(`'author${index}': '${node.name}'`)
        })
    }

    const allTopics = topicList.join(',')
    return (
            <Helmet
                htmlAttributes={{
                    lang,
                }}
                title={title}
                titleTemplate={title === 'Home' ? 'Bible to Life | Get to Know the Bible.' : `%s | ${defaultTitle}`}
            >
                <meta name="description" content={description} />
                <meta name="facebook-domain-verification" content="hp1sg2gl9y2ly50x9t2wywgh2yvhlq" />
                <meta name="image" content={image} />
                {(article ? true : null) && <meta property="og:type" content="article" />}
                {title && <meta property="og:title" content={title} />}
                {description && (
                    <meta property="og:description" content={description} />
                )}
                {image && <meta property="og:image" content={image} />}
                <meta name="twitter:card" content="summary_large_image" />
                {title && <meta name="twitter:title" content={title} />}
                {description && (
                    <meta name="twitter:description" content={description} />
                )}
                {image && <meta name="twitter:image" content={image} />}
                {url && <meta name="og:url" content={url} />}
                {allTopics &&
                <script>
                    {`
                    gtag('event', 'page_view', {
                        ${allTopics}
                    });
                    `}
                </script>
                }
            </Helmet>
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    image: PropTypes.string,
    article: PropTypes.bool,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo
